export default __webpack_public_path__ + "static/media/eco.6cd37dbd.jpg";